import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconClock = props => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <path d="m7.992 0c-4.416 0-7.992 3.584-7.992 8s3.576 8 7.992 8c4.424 0 8.008-3.584 8.008-8s-3.584-8-8.008-8zm0.00798 14.4c-3.536 0-6.4-2.864-6.4-6.4s2.864-6.4 6.4-6.4 6.4 2.864 6.4 6.4-2.864 6.4-6.4 6.4zm0.4-10.4h-1.2v4.8l4.2 2.52 0.6-0.984-3.6-2.136v-4.2z" />
  </SvgIcon>
);

export default IconClock;



// WEBPACK FOOTER //
// ./src/components/icons/IconClock.js